import React from 'react';

const PlayIcon = ({ className, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    {...props}
  >
    <path d="M8 5v14l11-7z" />
  </svg>
);

export default PlayIcon;
